"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyDetailsSummaryWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var SectionPanelTags_1 = require("../../SectionPanelTags");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualHomePropertyDetailsBanner_1 = require("./AnnualHomePropertyDetailsBanner");
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-key ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var DetailValue = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var AnnualHomePropertyDetailsSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyDetailsSummaryWidget, _super);
    function AnnualHomePropertyDetailsSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditPropertyDetailsPage = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "propertyDetailsWidgetId"
            });
            _this.props.engine.navigate("yourDetails", false);
        };
        _this.navigateToEditPropertyDetailsJourney = function () {
            journey_services_1.ObjectManipulator.setField("uistate.subprocess", _this.props.interaction, "changePropertyDetails");
            _this.props.engine.navigate("propertyDetails", false);
        };
        _this.fetchLookupValues = function () {
            var languageCode = "en-UK";
            var valuesToPopulate = [
                {
                    classifier: "roofMaterial",
                    field: _this.realEstate.roofMaterial,
                    stateName: "roofMaterial"
                },
                {
                    classifier: "wallMaterial",
                    field: _this.realEstate.externalWallMaterial,
                    stateName: "externalWallMaterial"
                },
                {
                    classifier: "flatRoofPercentage",
                    field: _this.realEstate.flatRoofPercentage,
                    stateName: "flatRoofPercentage"
                },
                {
                    classifier: "propertyListing",
                    field: _this.realEstate.propertyListing,
                    stateName: "propertyListing"
                }
            ];
            valuesToPopulate.forEach(function (item) {
                var lookupFieldValue = item.field == null ? undefined : item.field;
                _this.lookupService.fetchLookupValues(item.classifier, languageCode, lookupFieldValue).subscribe(function (lookupValues) {
                    var _a;
                    var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                    if (fetchedLookupItem) {
                        _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                    }
                });
            });
        };
        _this.realEstate = _this.props.interaction.realEstate[0];
        _this.state = {
            realEstateTypeSubType: "",
            externalWallMaterial: "",
            roofMaterial: "",
            flatRoofPercentage: "",
            propertyListing: "",
        };
        return _this;
    }
    AnnualHomePropertyDetailsSummaryWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues();
        this.fetchRealEstateTypeSubtypePresetParameters();
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.render = function () {
        var process = this.props.interaction.process;
        var isNB = process === services_1.INTERACTION_PROCESS_NB;
        var hasDebt = this.props.interaction.factors.debtAmount > 0;
        var image = ((0, jsx_runtime_1.jsx)("img", { className: "home-image grid-row-1-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-icon.png"), alt: "Home icon" }));
        var button = ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter", onClick: process === services_1.INTERACTION_PROCESS_NB
                ? this.navigateToEditPropertyDetailsPage
                : this.navigateToEditPropertyDetailsJourney, disabled: hasDebt, children: "Edit property details" }));
        if (isNB) {
            return ((0, jsx_runtime_1.jsx)("div", { id: "propertyDetailsWidgetId", className: "collapsible-question-panel quote-details-widget", children: (0, jsx_runtime_1.jsx)(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShownClassName: "shown", toggleShown: this.renderToggle("collapse-icon"), toggleHidden: this.renderToggle("expand-icon"), children: (0, jsx_runtime_1.jsxs)("div", { className: "accordion-content grid-make-2-col", children: [image, (0, jsx_runtime_1.jsx)("div", { className: "section border-0 p-0", children: (0, jsx_runtime_1.jsx)("div", { className: "section-contents mb-5", children: this.renderPropertyDetails() }) }), button] }) }) }));
        }
        return ((0, jsx_runtime_1.jsx)(SectionPanelTags_1.SectionPanel, { className: "annual-home-mta align-items-center page-contents-home-inner", children: (0, jsx_runtime_1.jsxs)(SectionPanelTags_1.Section, { className: "insured-address-section", children: [image, (0, jsx_runtime_1.jsx)(SectionPanelTags_1.SectionHeading, { children: "Property details" }), (0, jsx_runtime_1.jsxs)(SectionPanelTags_1.SectionContents, { children: [this.renderPropertyDetails(), button] })] }) }));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.renderToggle = function (iconClass) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "toggle d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-24", children: "Property details" }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon ".concat(iconClass) })] }));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.renderPropertyDetails = function () {
        var process = this.props.interaction.process;
        var isNB = process === services_1.INTERACTION_PROCESS_NB;
        var isRenewal = process === services_1.INTERACTION_PROCESS_RENEWAL;
        var isMta = process === services_1.INTERACTION_PROCESS_MTA || process === services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_MTA;
        var hasDebt = this.props.interaction.factors.debtAmount > 0;
        return ((0, jsx_runtime_1.jsxs)("div", { children: [isNB && (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Address:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: (0, commonFunctions_1.getFullAddressString)(this.realEstate.address) })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Property type:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.realEstateTypeSubType })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Number of bedrooms:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.bedroomCount })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Number of bathrooms:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.bathroomCount })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Good state of repair:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.propertyCondition === "GOOD" ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Walls:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.externalWallMaterial })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Roof:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.roofMaterial })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Percentage of flat roof:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.flatRoofPercentage })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Year built:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.yearBuilt })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Listed building:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.propertyListing })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Suffered from subsidence:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.subsidenceHeaveOrLandslip ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Been flooded:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.floodRisk ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Smart home systems:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.renderInstalledSmartHomeSystems() })] }), (0, jsx_runtime_1.jsxs)(Detail, { className: "margin-bottom-32", children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Oil-fired heating system:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.oilFiredHeatingInstalled ? "Yes" : "No" })] }), (isRenewal || isMta) &&
                    (0, jsx_runtime_1.jsx)(AnnualHomePropertyDetailsBanner_1.AnnualHomePropertyDetailsBanner, __assign({ disabledHyperlink: hasDebt }, this.props))] }));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.renderInstalledSmartHomeSystems = function () {
        var homeSystems = [];
        if (!this.realEstate.installedSmartHomeSystems) {
            homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "None" }));
        }
        else {
            if (this.realEstate.installedSmartHomeSystems.remoteHeatingControl) {
                homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "Remote heating control" }));
            }
            if (this.realEstate.installedSmartHomeSystems.securityCamera) {
                homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "Security camera" }));
            }
            if (this.realEstate.installedSmartHomeSystems.waterLeakDetector) {
                homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "Water leak detector" }));
            }
            if (this.realEstate.installedSmartHomeSystems.waterShutOffValve) {
                homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "Automatic water shut off valve" }));
            }
            if (homeSystems.length === 0) {
                homeSystems.push((0, jsx_runtime_1.jsx)("span", { children: "None" }));
            }
        }
        return ((0, jsx_runtime_1.jsx)("span", { children: homeSystems }));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.fetchRealEstateTypeSubtypePresetParameters = function () {
        var _this = this;
        this.falconConvenienceApiService.getRealEstateTypeSubtypeParams(services_1.PRODUCT_ANNUAL_HOME)
            .subscribe(function (output) {
            var _a;
            var arrayOfTypeSubType = output.filter(function (typeSubType) { return _this.props.interaction.realEstate[0].realEstateTypeSubType === typeSubType.typeSubTypeCode; });
            if (arrayOfTypeSubType.length === 1) {
                var resultText = arrayOfTypeSubType[0].subtype + " " + ((_a = arrayOfTypeSubType[0].type) !== null && _a !== void 0 ? _a : "").toLowerCase();
                _this.setState({
                    realEstateTypeSubType: (0, commonFunctions_1.capitalizeFirstLetter)(resultText.replace("None", ""))
                });
            }
        });
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyDetailsSummaryWidget.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyDetailsSummaryWidget.prototype, "falconConvenienceApiService", void 0);
    return AnnualHomePropertyDetailsSummaryWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomePropertyDetailsSummaryWidget = AnnualHomePropertyDetailsSummaryWidget;
//# sourceMappingURL=AnnualHomePropertyDetailsSummaryWidget.js.map